module.exports = __webpack_public_path__ + "img/door-opened-icon.c71d4fde.svg";